import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, FormCheck, Form, Button, Accordion } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import imageUrl from '../../assets/images/user.png';
import { useAuth } from "../../context/AuthContext";
import AlertModal from "../../Components/AlertModal";
import Message from "../../Components/Message";
import Loader from "../../Components/Loader";
import apiClient from "../../AppClient";

function StaffAddUpdate() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { currentUser } = useAuth();
    const [userData, setUserData] = useState({
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        phone: "",
        is_active: true,
        permissions: null,
        password: "",
        confirmPassword: "",
    });
    const [userDetails, setUserDetails] = useState({});
    const [allPermissions, setAllPermissions] = useState([]);
    const [imageFile, setImageFile] = useState(null);
    const [matchPassword, setMatchPassword] = useState(true);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [errorCreate, setErrorCreate] = useState("");

    useEffect(() => {
        // Fetch all permissions
        apiClient.get('/staff/permissions/')
            .then(response => {
                setAllPermissions(response.data);
            })
            .catch(error => console.log(error));

        // Fetch user data if id exists
        if (id) {
            setLoading(true);
            apiClient.get(`/staff/${id}/`)
                .then(response => {
                    setUserDetails(response.data);
                    setLoading(false);
                })
                .catch(error => {
                    setError(error.response.data.detail);
                    setLoading(false);
                });
        }
    }, [id]);

    useEffect(() => {
        if (userDetails) {
            const updatedPermissions = allPermissions.map((perm) => ({
                ...perm,
                checked: userDetails.permissions?.some((p) => p.id === perm.id) || false,
            }));

            setUserData((prev) => ({
                ...prev,
                first_name: userDetails.first_name,
                last_name: userDetails.last_name,
                username: userDetails.username,
                email: userDetails.email,
                phone: userDetails.phone,
                is_active: userDetails.is_active,
                permissions: updatedPermissions,
                password: "",
                confirmPassword: "",
            }));
        }
    }, [userDetails, allPermissions]); // <-- Make sure allPermissions is included


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });

        // Reset matchPassword if password or confirmPassword changes
        if (name === 'password' || name === 'confirmPassword') {
            setMatchPassword(true);
        }
    };

    const handlePermissionChange = (id, checked) => {
        setUserData({
            ...userData,
            permissions: userData.permissions.map((p) =>
                p.id === id ? { ...p, checked } : p
            ),
        });
    };
    const handleImageChange = (e) => {
        setImageFile(e.target.files[0]);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(""); // Clear previous errors
        setErrorCreate(""); // Clear previous errors

        if (userData.password !== userData.confirmPassword) {
            setMatchPassword(false);
            return;
        }

        const formData = new FormData();
        formData.append('first_name', userData.first_name);
        formData.append('last_name', userData.last_name);
        formData.append('username', userData.username);
        formData.append('email', userData.email);
        formData.append('phone', userData.phone);
        formData.append('is_active', userData.is_active);
        formData.append('password', userData.password);

        // Append permissions
        if (allPermissions.length > 0) {
            const permissionsToSend = userData.permissions.filter((p) => p.checked).map((p) => p.id);
            formData.append('permissions', JSON.stringify(permissionsToSend));
        }
        // Append image
        if (imageFile) {
            formData.append('image', imageFile);
        } else if (userDetails.image) {
            formData.append('image', userDetails.image); // Retain existing image if no new file is selected
        }

        if (id) {
            setLoadingUpdate(true);
            apiClient.put(`/staff/${id}/update/`, formData)
                .then(() => navigate('/staff/'))
                .catch(error => setErrorCreate(error.response.data.detail))
                .finally(() => setLoadingUpdate(false));
        } else {
            setLoadingCreate(true);
            apiClient.post('/staff/create/', formData)
                .then(() => navigate('/staff/'))
                .catch(error => setErrorCreate(error.response.data.detail))
                .finally(() => setLoadingCreate(false));
        }
    };

    return (
        <Container>
            <div className='w-100 d-flex justify-content-between'>
                <Link to='/staff/' className='btn btn-outline-secondary my-2'>رجوع</Link>
            </div>
            <h3>{id ? 'تعديل المستخدم' : 'إضافة مستخدم جديد'}</h3>


            <Form onSubmit={handleSubmit}>
                <Row className="d-none justify-content-md-center text-center">
                    <Col md={10}>
                        <Image
                            src={
                                imageFile
                                    ? URL.createObjectURL(imageFile)
                                    : userDetails.image
                                        ? `${process.env.REACT_APP_API_URL}${userDetails.image}`
                                        : imageUrl
                            }
                            roundedCircle
                            width={150}
                            height={150}
                        />
                        <div>
                            <input type="file" id="fileInput" style={{ display: 'none' }} onChange={handleImageChange} />
                            <Button variant="outline-primary" className="mx-2" onClick={() => document.getElementById('fileInput').click()}>
                                تعديل الصورة
                            </Button>
                            <AlertModal
                                myaction={() => setImageFile(null)}
                                message="Are you sure you want to delete your profile image?"
                                title="Delete Image"
                                customebutton={
                                    <Button variant="outline-danger" className="btn">
                                        <i className='fas fa-trash me-1'></i>
                                        حذف الصورة
                                    </Button>
                                }
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>الاسم الاول</Form.Label>
                            <Form.Control type="text" name="first_name" required value={userData.first_name} onChange={handleInputChange} />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>الاسم الاخير</Form.Label>
                            <Form.Control type="text" name="last_name" required value={userData.last_name} onChange={handleInputChange} />
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group className="d-none mb-3">
                    <Form.Label>اسم المستخدم</Form.Label>
                    <Form.Control type="text" name="username" required value={userData.username} onChange={handleInputChange} />
                </Form.Group>
                <Form.Group className="mb-3">
                    <Form.Label>البريد الاليكتروني</Form.Label>
                    <Form.Control type="email" name="email" required value={userData.email} onChange={handleInputChange} />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>الهاتف</Form.Label>
                    <Form.Control type="text" name="phone" value={userData.phone} onChange={handleInputChange} />
                </Form.Group>

                <Row>
                {id && (
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>الحالة</Form.Label>
                            <Form.Select
                                className={userData.is_active ? "text-success" : "text-danger"}
                                value={userData.is_active ? "true" : "false"} // Corrected logic
                                onChange={(e) => setUserData({ ...userData, is_active: e.target.value === "true" })}
                            >
                                <option value="true">نشط</option>
                                <option value="false">غير نشط</option>
                            </Form.Select>
                        </Form.Group>

                    </Col>
                )}
                </Row>

                <Accordion defaultActiveKey="0" className="mt-4 w-75">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>الصلاحيات</Accordion.Header>
                        <Accordion.Body>
                            <Row>
                                {allPermissions.map((permission) => (
                                    <Col key={permission.id} md={6}>
                                        <Form.Check
                                            type="switch"
                                            label={permission.name}
                                            checked={userData.permissions.some((p) => p.id === permission.id && p.checked)}
                                            onChange={(e) => handlePermissionChange(permission.id, e.target.checked)}
                                        />
                                    </Col>
                                ))}
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>

                <Form.Group className="mb-3">
                    <Form.Label>كلمة المرور</Form.Label>
                    <Form.Control type="password" name="password" value={userData.password} onChange={handleInputChange} />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>تأكيد كلمة المرور</Form.Label>
                    <Form.Control type="password" name="confirmPassword" value={userData.confirmPassword} onChange={handleInputChange} />
                    {!matchPassword && <div className="text-danger mt-2">كلمة المرور غير متطابقة</div>}
                </Form.Group>
                {loading ? <Loader size={50} /> : error ? <Message variant='danger'>{error}</Message> : null}
                {loadingCreate || loadingUpdate ? <Loader size={50} /> : errorCreate ? <Message variant='danger'>{errorCreate}</Message> : null}

                <Button variant="danger" className="my-3" onClick={() => navigate('/staff/')}>Cancel</Button>
                <Button variant="primary" className="my-3" type="submit">{id ? 'تحديث' : 'إضافة'}</Button>
            </Form>
        </Container>
    );
}

export default StaffAddUpdate;